export default {
    getSavers: state => state.savers,
    getSaverProfile: state => state.saverProfile,
    saverTransactions: state => state.transactions,
    getSaverDetails: state => state.saverDetails,
    getPiggys: state => state.piggys

}